/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    .factory("$notifications", [
        "$timeout",
        function (timeout) {
            var notifications = {
                //
                get show() {
                    return this.pending.length > 0;
                },
                //
                pending: [],
                //
                addInfo: function (message, details) {
                    var notification = {
                        type: "info",
                        message: message,
                        details: details
                    };
                    this.pending.push(notification);
                    timeout(() => {
                        this.close(notification);
                    }, 5000);
                },
                //
                addSuccess: function (message, details) {
                    var notification = {
                        type: "success",
                        message: message,
                        details: details
                    };
                    this.pending.push(notification);
                    timeout(() => {
                        this.close(notification);
                    }, 5000);
                },
                //
                addError: function (message, details) {
                    var notification = {
                        type: "danger",
                        message: message,
                        details: details
                    };
                    this.pending.push(notification);
                },
                //
                close: function (notification) {
                    var index = this.pending.indexOf(notification);
                    this.pending.splice(index, 1);
                }
            };
            return notifications;
        }
    ])
    //
    .config([
        "$httpProvider",
        function (httpProvider) {
            httpProvider.interceptors.push([
                "$q", "$notifications", "$translate",
                function ($q, notifications, translate) {
                    function unprocessable(rejection) {
                        var errors = [];
                        Object.keys(rejection.data).forEach(function (key, idx) {
                            errors.push(rejection.data[key].join('\n'));
                        });

                        translate('ValidationError')
                            .then(function (translation) {
                                notifications.addError(translation, errors.join('\n'));
                            }, function () {
                                notifications.addError('Validation Error', errors.join('\n'));
                            })
                    }

                    function internalError(rejection) {
                        if (rejection.data !== null) {
                            notifications.addError(
                                rejection.data.Name,
                                rejection.data.Message
                            );
                        }
                        else {
                            unknownError();
                        }
                    }

                    function notFoundError() {
                        translate(['NotFoundException.Message', 'NotFoundException.Name'])
                            .then(function (translations) {
                                console.log(translations);
                                notifications.addError(
                                    translations['NotFoundException.Name'],
                                    translations['NotFoundException.Message']
                                );
                            }, function () {
                                notifications.addError(
                                    'Not found',
                                    'Resource was not found'
                                );
                            })
                    }

                    function unknownError() {
                        translate(['GeneralException.Message', 'GeneralException.Name'])
                            .then(function (translations) {
                                notifications.addError(
                                    translations['GeneralException.Name'],
                                    translations['GeneralException.Message']
                                );
                            }, function () {
                                notifications.addError(
                                    'Error',
                                    'An error occured'
                                );
                            })
                    }

                    function requestError(rejection) {
                        translate(rejection.status + " " + rejection.statusText)
                            .then(function (translation) {
                                notifications.addError(
                                    translation,
                                    rejection.data.InnerException ?
                                        rejection.data.InnerException.Message + " " + rejection.data.InnerException.ExceptionMessage :
                                        rejection.data.Message + " " + rejection.data.ExceptionMessage
                                );
                            }, function () {
                                notifications.addError(
                                    rejection.status + " " + rejection.statusText,
                                    rejection.data.InnerException ?
                                        rejection.data.InnerException.Message + " " + rejection.data.InnerException.ExceptionMessage :
                                        rejection.data.Message + " " + rejection.data.ExceptionMessage
                                );
                            });
                    }

                    return {
                        //
                        request: function (config) {
                            return config;
                        },
                        //
                        requestError: function (rejection) {
                            requestError(rejection);

                            return $q.reject(rejection);
                        },
                        //
                        response: function (response) {
                            return response;
                        },
                        //
                        responseError: function (rejection) {
                            if (!rejection.config.skipInterceptors) {
                                if (rejection.status === 400) {
                                    unprocessable(rejection);
                                }
                                else if (rejection.status === 500) {
                                    internalError(rejection);
                                }
                                else if (rejection.status === 404) {
                                    notFoundError();
                                }
                                else {
                                    unknownError();
                                }
                            }
                            return $q.reject(rejection);
                        }
                    };
                }
            ]);
        }
    ]);